import { render, staticRenderFns } from "./manage-study.vue?vue&type=template&id=a63a8284&"
import script from "./manage-study.vue?vue&type=script&lang=ts&"
export * from "./manage-study.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports